import { cn } from '@/lib/utils'

type SegmentedControlProps<T extends string | boolean> = {
  ariaLabel: string
  value: T
  onChange(value: T): void
  options: readonly { value: T; label: string }[]
  size?: 'sm' | 'xs'
}

/** A row of mutually exclusive buttons, such as Active / Inactive / All. */
export function SegmentedControl<T extends string | boolean>({
  ariaLabel,
  value,
  onChange,
  options,
  size = 'sm'
}: SegmentedControlProps<T>): React.JSX.Element {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className={cn(
        'inline-flex overflow-hidden rounded-md border bg-card',
        size === 'xs' ? 'text-xs' : 'text-sm'
      )}
    >
      {options.map((option) => (
        <button
          key={String(option.value)}
          type="button"
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            'border-r py-1 transition-colors last:border-r-0',
            size === 'xs' ? 'px-2.5' : 'px-3',
            value === option.value
              ? 'bg-primary/10 font-medium text-primary'
              : 'text-muted-foreground hover:bg-muted'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
